<form #jobStatisticsForm class="form-v2">
    <div class="form-group row">
        <div class="col-md-6 readonly-shared">
            <label>Jobs in Progress</label>
            <input
                legacy-css
                type="text"
                class="form-control form-control-v2 readonly-shared-input"
                id=""
                name="jobsInProgress"
                [value]="jobStatistics.jobsInProgress"
                disabled />
            <span class="lock"></span>
        </div>
        <div class="col-md-6 readonly-shared">
            <label>Jobs In Progress Value</label>
            <input
                legacy-css
                type="text"
                class="form-control form-control-v2 readonly-shared-input"
                id=""
                name="jobsInProgressValue"
                [value]="jobStatistics.jobsInProgressValue"
                disabled />
            <span class="lock"></span>
        </div>
    </div>
    <div class="form-group row">
        <div class="col-md-6 readonly-shared">
            <label>Yearly Completed Jobs</label>
            <input
                legacy-css
                type="text"
                class="form-control form-control-v2 readonly-shared-input"
                id=""
                name="yearlyCompletedJobs"
                [value]="jobStatistics.yearlyCompletedJobs"
                disabled />
            <span class="lock"></span>
        </div>
        <div class="col-md-6 readonly-shared">
            <label>Yearly Completed Jobs Value</label>
            <input
                legacy-css
                type="text"
                class="form-control form-control-v2 readonly-shared-input"
                id=""
                name="yearlyCompletedJobsValue"
                [value]="jobStatistics.yearlyCompletedJobsValue"
                disabled />
            <span class="lock"></span>
        </div>
    </div>
    <div class="form-group row">
        <div class="col-md-6 readonly-shared">
            <label>Total Material In Progress Value</label>
            <input
                legacy-css
                type="text"
                class="form-control form-control-v2 readonly-shared-input"
                id=""
                name="totalMaterialInProgressValue"
                [value]="jobStatistics.totalMaterialInProgressValue"
                disabled />
            <span class="lock"></span>
        </div>
    </div>
</form>
